
// // import React from 'react';
// // import { Grid, Paper, Typography, Button, Box } from '@mui/material';
// // import { styled } from '@mui/system';
// // import PropTypes from 'prop-types';
// // import { Link } from 'react-router-dom';

// // // Styled components for the BlogMiniCard
// // const StyledPaper = styled(Paper)(({ theme }) => ({
// //     padding: theme.spacing(2),
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'flex-start',
// //     textAlign: 'left',
// //     border: 'none',
// //     boxShadow: theme.shadows[0],
// //     width: '100%',
// //     maxWidth: '332px',
// // }));

// // const Image = styled('img')({
// //     width: '100%',
// //     height: 'auto',
// //     maxWidth: '332px',
// // });

// // const Title = styled(Typography)(({ theme }) => ({

// //     fontWeight: 700,
// //     fontSize: '24px',
// //     lineHeight: '36px',
// //     margin: '1rem 0',
// //     width: '100%',
// //     [theme.breakpoints.down('sm')]: {
// //         width: '100%', // Width for mobile screens
// //         fontSize: '20px',
// //     },
// //     [theme.breakpoints.down('md')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// // }));

// // const Content = styled(Typography)(({ theme }) => ({
// //     fontWeight: 400,
// //     fontSize: '16px',
// //     lineHeight: '20.83px',
// //     textAlign: 'justify',
// //     width: '100%', // Default width for larger screens
// //     marginBottom: '1rem',
// //     overflow: 'hidden',
// //     display: '-webkit-box',
// //     WebkitBoxOrient: 'vertical',
// //     WebkitLineClamp: 6,
// //     [theme.breakpoints.down('sm')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// //     [theme.breakpoints.down('md')]: {
// //         width: '100%', // Width for mobile screens
// //     },
// // }));

// // const ReadMoreButton = styled(Button)({
// //     width: '50%',
// //     maxWidth: '182px',
// //     height: '2.7rem',
// //     borderRadius: '1.5rem',
// //     border: '2px solid',
// //     borderColor: '#000',
// //     alignSelf: 'flex-start',
// //     marginTop: '1rem',
// // });

// // const truncateContent = (text, maxLength) => {
// //     if (text.length <= maxLength) return text;
// //     return text.substring(0, maxLength) + '...';
// // };




// // const BlogLargeCard = ({ id, image, title, blogDate, content }) => (


// //     <Grid item xs={12} sm={12} md={4} mt={2} mb={2} sx={{
// //         mx: {
// //             xs: 0, // Margin on x-axis for extra small screens
// //             md: 20,
// //             sm: 16 // Margin on x-axis for small screens and up
// //         }
// //     }}>

// //         <StyledPaper>
// //             <Box
// //                 sx={{
// //                     width: { xs: '100%', sm: '600px', md: '734px' },
// //                     margin: '0 auto',
// //                     display: 'flex',
// //                     flexDirection: 'column'
// //                 }}
// //             >
// //                 <Box
// //                     sx={{
// //                         width: '100%',
// //                         height: { xs: 'auto', sm: '300px', md: '358px' },
// //                         overflow: 'hidden',
// //                         position: 'relative'
// //                     }}
// //                 >
// //                     <img
// //                         src={`${process.env.PUBLIC_URL}/blogImages/${id}.jpg`}
// //                         alt={title}
// //                         onError={(e) => { e.target.onerror = null; }}
// //                         style={{
// //                             width: '100%',
// //                             height: '100%',
// //                             objectFit: 'cover'
// //                         }}
// //                     />
// //                 </Box>
// //                 <Box
// //                     sx={{
// //                         width: '100%',
// //                         padding: { xs: 1, sm: 2 },
// //                         boxSizing: 'border-box'
// //                     }}
// //                 >
// //                     <Title>{title}</Title>
// //                     <Typography
// //                         variant="subtitle1"
// //                         sx={{
// //                             width: '100%',
// //                             textAlign: 'left',
// //                             marginBottom: '1rem'
// //                         }}
// //                     >
// //                         {blogDate}
// //                     </Typography>
// //                     <Content
// //                         sx={{
// //                             textAlign: 'justify',
// //                             width: '100%'
// //                         }}
// //                     >
// //                         {truncateContent(content, 200)}
// //                     </Content>

// //                     <Button
// //                         component={Link}
// //                         to={`/blog/${id}`}
// //                         variant="contained"
// //                         sx={{
// //                             backgroundColor: 'white',
// //                             color: 'black',
// //                             border: '2px solid black',
// //                             marginTop: '10px',
// //                             '&:hover': {
// //                                 backgroundColor: 'primary',
// //                                 color: 'white',
// //                                 border: '2px solid white',
// //                             },
// //                         }}
// //                     >
// //                         Continue Reading
// //                     </Button>
// //                 </Box>
// //             </Box>
// //         </StyledPaper>
// //     </Grid>
// // );

// // BlogLargeCard.propTypes = {
// //     id: PropTypes.number.isRequired,
// //     image: PropTypes.string.isRequired,
// //     title: PropTypes.string.isRequired,
// //     blogDate: PropTypes.string.isRequired,
// //     content: PropTypes.string.isRequired,
// // };

// // export default BlogLargeCard;
// import React from 'react';
// import { Grid, Paper, Typography, Button, Box } from '@mui/material';
// import { styled } from '@mui/system';
// import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';

// // Styled components for the BlogLargeCard
// const StyledPaper = styled(Paper)(({ theme }) => ({
//     padding: theme.spacing(2),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'flex-start',
//     textAlign: 'left',
//     border: 'none',
//     boxShadow: theme.shadows[0],
//     width: '100%',
//     maxWidth: '734px', // Ensure this is wide enough for larger screens
//     margin: '0 auto', // Center the Paper in its Grid item
// }));

// const Image = styled('img')({
//     width: '100%',
//     height: 'auto',
//     objectFit: 'cover',
// });

// const Title = styled(Typography)(({ theme }) => ({
//     fontWeight: 700,
//     fontSize: '24px',
//     lineHeight: '36px',
//     margin: '1rem 0',
//     width: '100%',
//     [theme.breakpoints.down('sm')]: {
//         fontSize: '20px',
//     },
// }));

// const Content = styled(Typography)(({ theme }) => ({
//     fontWeight: 400,
//     fontSize: '16px',
//     lineHeight: '20.83px',
//     textAlign: 'justify',
//     width: '100%',
//     marginBottom: '1rem',
//     overflow: 'hidden',
//     display: '-webkit-box',
//     WebkitBoxOrient: 'vertical',
//     WebkitLineClamp: 6,
//     [theme.breakpoints.down('sm')]: {
//         fontSize: '14px',
//     },
// }));

// const ReadMoreButton = styled(Button)({
//     width: '100%',
//     maxWidth: '182px',
//     height: '2.7rem',
//     borderRadius: '1.5rem',
//     border: '2px solid',
//     borderColor: '#000',
//     alignSelf: 'flex-start',
//     marginTop: '1rem',
// });

// const truncateContent = (text, maxLength) => {
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
// };

// const BlogLargeCard = ({ id, image, title, blogDate, content }) => (
//     <Grid item xs={12} sm={12} md={4} mt={2} mb={2}>
//         <StyledPaper>
//             <Box
//                 sx={{
//                     width: '100%',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     margin: '0 auto',
//                 }}
//             >
//                 <Box
//                     sx={{
//                         width: '100%',
//                         height: 'auto',
//                         position: 'relative',
//                     }}
//                 >
//                     <Image
//                         src={`${process.env.PUBLIC_URL}/blogImages/${id}.jpg`}
//                         alt={title}
//                     />
//                 </Box>
//                 <Box
//                     sx={{
//                         width: '100%',
//                         padding: { xs: 1, sm: 2 },
//                         boxSizing: 'border-box',
//                     }}
//                 >
//                     <Title>{title}</Title>
//                     <Typography
//                         variant="subtitle1"
//                         sx={{
//                             width: '100%',
//                             textAlign: 'left',
//                             marginBottom: '1rem',
//                         }}
//                     >
//                         {blogDate}
//                     </Typography>
//                     <Content>
//                         {truncateContent(content, 200)}
//                     </Content>
//                     <ReadMoreButton
//                         component={Link}
//                         to={`/blog/${id}`}
//                         variant="contained"
//                         sx={{
//                             backgroundColor: 'white',
//                             color: 'black',
//                             border: '2px solid black',
//                             '&:hover': {
//                                 backgroundColor: 'black',
//                                 color: 'white',
//                                 border: '2px solid white',
//                             },
//                         }}
//                     >
//                         Continue Reading
//                     </ReadMoreButton>
//                 </Box>
//             </Box>
//         </StyledPaper>
//     </Grid>
// );

// BlogLargeCard.propTypes = {
//     id: PropTypes.number.isRequired,
//     image: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     blogDate: PropTypes.string.isRequired,
//     content: PropTypes.string.isRequired,
// };

// export default BlogLargeCard;
import React from 'react';
import { Grid, Paper, Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CLIQLOAN_BRAND } from '../../theme/cliqloanBrand';
import { CLIQLOAN_TYPO, readMoreButtonSx } from '../../theme/cliqloanTypography';

// Styled components for the BlogLargeCard
const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    border: 'none',
    boxShadow: theme.shadows[0],
    width: '100%',
}));

const ImageContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    aspectRatio: '16 / 9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CLIQLOAN_BRAND.lightGray,
    borderRadius: theme.spacing(1.5),
    overflow: 'hidden',
}));

const Image = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
});

const Title = styled(Typography)(() => ({
    ...CLIQLOAN_TYPO.cardTitle,
    fontFamily: CLIQLOAN_TYPO.fontFamily,
    width: '100%',
    color: CLIQLOAN_BRAND.deepPurple,
    lineHeight: 1.35,
}));

const Content = styled(Typography)(() => ({
    fontWeight: 400,
    ...CLIQLOAN_TYPO.cardBody,
    fontFamily: CLIQLOAN_TYPO.fontFamily,
    textAlign: 'left',
    width: '100%',
    color: CLIQLOAN_BRAND.textMuted,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 5,
}));

const ReadMoreButton = styled(Button)(() => ({
    flexShrink: 0,
}));

const truncateContent = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

const BlogLargeCard = ({ slug, image, imageAlt, imageWidth, imageHeight, title, blogDate, description, layout = 'default' }) => (
    <Grid container justifyContent="center">
        <Grid 
            item
            xs={12}
            sm={12}
            md={10}
            mt={2}
            mb={2}
            ml={{ xs: 0, md: 2 }}
            mr={{ xs: 0, md: 2 }}
        >
            <StyledPaper>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: {
                            xs: 'column',
                            md: layout === 'right' ? 'row-reverse' : layout === 'left' ? 'row' : 'column',
                        },
                        margin: '0 auto',
                        gap: { md: 3 },
                    }}
                >
                    <ImageContainer>
                        <picture style={{ display: 'block', width: '100%', height: '100%' }}>
                            <source srcSet={`${process.env.PUBLIC_URL}${image.replace(/\.png$/i, '.avif')}`} type="image/avif" />
                            <source srcSet={`${process.env.PUBLIC_URL}${image.replace(/\.png$/i, '.webp')}`} type="image/webp" />
                            <Image
                                src={`${process.env.PUBLIC_URL}${image}`}
                                alt={imageAlt || title}
                                width={imageWidth}
                                height={imageHeight}
                                loading="eager"
                                decoding="sync"
                                fetchpriority="high"
                                onError={(e) => { e.target.onerror = null; }}
                            />
                        </picture>
                    </ImageContainer>
                    <Box
                        sx={{
                            flex: { md: 1 },
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.5,
                            padding: { xs: 2, sm: 2.5, md: 3 },
                            boxSizing: 'border-box',
                        }}
                    >
                        <Title>{title}</Title>
                        {blogDate && (
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    width: '100%',
                                    textAlign: 'left',
                                    fontFamily: CLIQLOAN_TYPO.fontFamily,
                                    fontWeight: 400,
                                    ...CLIQLOAN_TYPO.bodySm,
                                    color: CLIQLOAN_BRAND.textMuted,
                                }}
                            >
                                {blogDate}
                            </Typography>
                        )}
                        <Content sx={{ flex: 1 }}>
                            {truncateContent(description, 260)}
                        </Content>
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', pt: 0.5 }}>
                            <ReadMoreButton
                                component={Link}
                                to={`/blog/${slug}/`}
                                variant="contained"
                                sx={readMoreButtonSx}
                            >
                                Continue Reading
                            </ReadMoreButton>
                        </Box>
                    </Box>
                </Box>
            </StyledPaper>
        </Grid>
    </Grid>
);

BlogLargeCard.propTypes = {
    slug: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    imageWidth: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    blogDate: PropTypes.string,
    description: PropTypes.string.isRequired,
    layout: PropTypes.oneOf(['left', 'right', 'default']),
};

export default BlogLargeCard;
